module.exports = __webpack_public_path__ + "media/images/admin/icons/compass-d03702e2ce6c832f5c9d020faa58cacf.svg";